// Biweekly pay period utility (mirrors backend utils/payPeriod.js)
// Periods run Saturday–Friday (14 days); pay day is the Friday 7 days after period end
// Anchor: June 6 (Sat)–June 19 (Fri) → pay day June 26; July 4–July 17 → pay day July 24
const ANCHOR_PERIOD_START_MS = Date.UTC(2026, 5, 6);  // June 6, 2026 (Saturday)
const ANCHOR_PAYDAY_MS       = Date.UTC(2026, 5, 26); // June 26, 2026 (Friday)
const PERIOD_MS = 14 * 24 * 60 * 60 * 1000;
const DAY_MS    = 24 * 60 * 60 * 1000;

export function getPayDayStr(shdate) {
  if (!shdate) return null;
  const [y, m, d] = shdate.split('-').map(Number);
  const shiftMs = Date.UTC(y, m - 1, d);
  const daysSincePeriodStart = Math.round((shiftMs - ANCHOR_PERIOD_START_MS) / DAY_MS);
  const periodIndex = Math.floor(daysSincePeriodStart / 14);
  const payDayMs = ANCHOR_PAYDAY_MS + periodIndex * PERIOD_MS;
  const pd = new Date(payDayMs);
  const py = pd.getUTCFullYear();
  const pm = String(pd.getUTCMonth() + 1).padStart(2, '0');
  const pdd = String(pd.getUTCDate()).padStart(2, '0');
  return `${py}-${pm}-${pdd}`;
}

function todayUTCStr() {
  const d = new Date();
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

export function isPayDayPassed(shdate) {
  if (!shdate) return false;
  return getPayDayStr(shdate) <= todayUTCStr();
}

// Format YYYY-MM-DD → M/D
export function fmtPayDay(shdate) {
  const s = getPayDayStr(shdate);
  if (!s) return '—';
  const [, m, d] = s.split('-');
  return `${parseInt(m)}/${parseInt(d)}`;
}
